/**
 * La boîte RÉELLEMENT peinte par un élément du canvas.
 *
 * Chaque bloc est enveloppé par `BlockRenderer` dans un `<span style="display:contents">` qui porte le
 * `data-aqx-block-id` : un tel nœud ne génère AUCUNE boîte, donc `getBoundingClientRect()` y renvoie
 * 0×0 à l'origine. On mesure alors l'union de ses enfants — c'est ce que voit la vendeuse.
 *
 * Vit à part de <CanvasFrame> parce que la mise en vue horizontale (`revealInTracks`) en a besoin sans
 * tirer tout le registre des sections derrière elle.
 */
export function measureBox(el: Element): { l: number; t: number; r: number; b: number } | null {
  if (getComputedStyle(el).display === 'contents') {
    let u: { l: number; t: number; r: number; b: number } | null = null;
    for (const child of Array.from(el.children)) {
      const r = child.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) continue; // skip <style>/zero-box nodes
      u = u
        ? {
            l: Math.min(u.l, r.left),
            t: Math.min(u.t, r.top),
            r: Math.max(u.r, r.right),
            b: Math.max(u.b, r.bottom),
          }
        : { l: r.left, t: r.top, r: r.right, b: r.bottom };
    }
    return u;
  }
  const r = el.getBoundingClientRect();
  return { l: r.left, t: r.top, r: r.right, b: r.bottom };
}
